import React from "react"
import { useStaticQuery, graphql } from "gatsby"

export default ({ src, render }) => {
  const gql = graphql`
    query {
      allPlainText(sort: { fields: [data___relativePath], order: ASC }) {
        nodes {
          data {
            content
            relativePath
          }
        }
      }
    }
  `

  if (!src) throw new Error("`src` required for PlainTextProver")

  const files = useStaticQuery(gql)
    .allPlainText.nodes.map((node) => node.data)
    .filter(({ relativePath, content }) => relativePath.startsWith(src) && content)

  return <>{files.map(({ relativePath, content }) => render(content || null, relativePath.replace(/^.*\//, "")))}</>
}
